import { Dispatch } from 'redux'
import { getType } from 'typesafe-actions'
import { selectCall } from '../reducers/janus'
import { actions } from '../types'
import { SagaContext } from './types'

export default async function script(ctx: SagaContext) {
  const onIncomingCall = new URLSearchParams(window.location.search).get('onIncomingCall')
  if (!onIncomingCall) { return }
  let script

  try {
    script = parseScript(onIncomingCall, ctx.dispatch)
  } catch(e) {
    console.error(e)
    return
  }

  let ac: AbortController | undefined

  for (; ;) {
    const action = await ctx.takeAny()
    const state = ctx.getState()

    switch (action.type) {
      case getType(actions.callStatusChanged): {
        const call = selectCall(state)
        if (call && call.canAnswer && !call.answerRequested) {
          ac?.abort()
          ac = new AbortController()

          // forking (without await)
          run(script, ac.signal)
        } else if (call.status === 'idle') {
          ac?.abort()
        }
      }
    }
  }
}

type ScriptCommand = () => any | Promise<any>

function parseScript(script: string, dispatch: Dispatch): ScriptCommand[] {
  return script.split(',')
    .map(cmd => {
      switch (cmd[0]) {
        case 'a':
          return () => dispatch(actions.answer())
        case 'w':
          return () => delay(parseInt(cmd.substr(1)))
        case 'h':
          return () => dispatch(actions.hold())
        case 'r':
          return () => dispatch(actions.resume())
        case 'u':
          return () => dispatch(actions.hangUp())
      }

      throw new Error('Unable to parse: ' + cmd)
    })
}

async function run(script: ScriptCommand[], signal: AbortSignal) {
  for (const cmd of script) {
    if (signal.aborted) { return }
    await cmd()
  }
}

function delay(ms: number) {
  return new Promise<void>(resolve => {
    window.setTimeout(() => resolve(), ms)
  })
}
